export default [
    {
        "text": "宾馆餐娱类",
        "children": [
            {
                "text": "宾馆类",
                "children": [
                    {
                        "text": "住宿服务"
                    },
                    {
                        "text": "分时度假房地产"
                    }
                ]
            },
            {
                "text": "餐饮类",
                "children": [
                    {
                        "text": "包办伙食，宴会承包商"
                    },
                    {
                        "text": "就餐场所和餐馆"
                    },
                    {
                        "text": "休闲饮品场所、酒吧、咖啡厅、茶馆"
                    },
                    {
                        "text": "快餐店"
                    }
                ]
            },
            {
                "text": "珠宝工艺类",
                "children": [
                    {
                        "text": "贵重珠宝、首饰、钟表零售"
                    },
                    {
                        "text": "古玩艺术品销售"
                    },
                    {
                        "text": "古玩复制店"
                    },
                    {
                        "text": "银器店"
                    },
                    {
                        "text": "玻璃、陶瓷、水晶制品商店"
                    },
                    {
                        "text": "工艺美术商店"
                    },
                    {
                        "text": "艺术商和画廊"
                    },
                    {
                        "text": "手表、钟表和首饰维修店"
                    }
                ]
            },
            {
                "text": "娱乐类",
                "children": [
                    {
                        "text": "集体活动服务商，夏令营、拓展训练"
                    },
                    {
                        "text": "宿营场地"
                    },
                    {
                        "text": "按摩足疗店"
                    },
                    {
                        "text": "保健、美容及洗浴服务"
                    },
                    {
                        "text": "影视、音像制品创作、发行"
                    },
                    {
                        "text": "歌舞厅、卡拉OK"
                    },
                    {
                        "text": "舞台演出服务及票务"
                    },
                    {
                        "text": "未列入其他代码的文艺表演、艺术创作"
                    },
                    {
                        "text": "台球娱乐场所"
                    },
                    {
                        "text": "保龄球馆"
                    },
                    {
                        "text": "运动比赛场馆、体育俱乐部、赛事推广"
                    },
                    {
                        "text": "高尔夫球场"
                    },
                    {
                        "text": "大型游戏机和游戏场所"
                    },
                    {
                        "text": "游乐园、马戏馆、嘉年华"
                    },
                    {
                        "text": "会员制体育健身俱乐部、会所"
                    },
                    {
                        "text": "动物园、海洋馆"
                    },
                    {
                        "text": "未列入其他代码的娱乐服务"
                    },
                    {
                        "text": "电影院"
                    }
                ]
            }
        ]
    },
    {
        "text": "房产汽车类",
        "children": [
            {
                "text": "房地产类",
                "children": [
                    {
                        "text": "住宅与商业地产开发商"
                    },
                    {
                        "text": "房产服务商、经纪"
                    },
                    {
                        "text": "建设工程"
                    }
                ]
            },
            {
                "text": "汽车销售类",
                "children": [
                    {
                        "text": "拖挂式活动房车经销商"
                    },
                    {
                        "text": "汽车经销商"
                    },
                    {
                        "text": "二手车经销商"
                    },
                    {
                        "text": "船只销售商"
                    },
                    {
                        "text": "旅行用车销售商"
                    },
                    {
                        "text": "摩托车商店"
                    },
                    {
                        "text": "房车销售商"
                    },
                    {
                        "text": "雪车商"
                    },
                    {
                        "text": "未列入其他代码的机动车、飞行器、农业机械经销商"
                    }
                ]
            },
            {
                "text": "理财类",
                "children": [
                    {
                        "text": "典当、拍卖"
                    },
                    {
                        "text": "金融机构-商品和服务"
                    }
                ]
            }
        ]
    },
    {
        "text": "百货一般类",
        "children": [
            {
                "text": "旅游售票类",
                "children": [
                    {
                        "text": "旅行社"
                    },
                    {
                        "text": "景区售票"
                    }
                ]
            },
            {
                "text": "日用百货类",
                "children": [
                    {
                        "text": "男性服饰商店"
                    },
                    {
                        "text": "女性服饰商店"
                    },
                    {
                        "text": "女性饰品商店"
                    },
                    {
                        "text": "婴儿、儿童用品店"
                    },
                    {
                        "text": "服装综合零售店"
                    },
                    {
                        "text": "运动服饰商店"
                    },
                    {
                        "text": "鞋店"
                    },
                    {
                        "text": "皮货店"
                    },
                    {
                        "text": "成人成衣店"
                    },
                    {
                        "text": "假发商店"
                    },
                    {
                        "text": "未列入其他代码的服饰商店"
                    },
                    {
                        "text": "地板、地毯商店"
                    },
                    {
                        "text": "窗帘、遮阳棚商店"
                    },
                    {
                        "text": "家庭装饰用品商店"
                    },
                    {
                        "text": "箱包、皮具店"
                    },
                    {
                        "text": "纺织品及针织品零售"
                    },
                    {
                        "text": "化妆品商店"
                    },
                    {
                        "text": "电动剃刀商店－销售和服务"
                    },
                    {
                        "text": "商品服务买卖居间活动、团购"
                    },
                    {
                        "text": "建材销售"
                    },
                    {
                        "text": "玻璃、油漆涂料、墙纸零售"
                    },
                    {
                        "text": "五金商店"
                    },
                    {
                        "text": "草坪、园艺用品商店"
                    },
                    {
                        "text": "免税商店"
                    },
                    {
                        "text": "折扣商店"
                    },
                    {
                        "text": "百货商店"
                    },
                    {
                        "text": "各类杂货店、便利店"
                    },
                    {
                        "text": "家具及家居生活用品"
                    },
                    {
                        "text": "壁炉、壁炉防护网及配件商店"
                    },
                    {
                        "text": "电子设备商店"
                    },
                    {
                        "text": "旧货及二手商品店"
                    },
                    {
                        "text": "自行车商店"
                    },
                    {
                        "text": "运动器材装备商店"
                    },
                    {
                        "text": "书店"
                    },
                    {
                        "text": "文具商店"
                    },
                    {
                        "text": "玩具店"
                    },
                    {
                        "text": "礼品、纪念品、节日装饰品商店"
                    },
                    {
                        "text": "宗教用品商店"
                    },
                    {
                        "text": "燃料经销商（除机动车燃料）"
                    },
                    {
                        "text": "花店"
                    },
                    {
                        "text": "未列入其他代码的专门零售店"
                    },
                    {
                        "text": "光学仪器、眼镜店"
                    },
                    {
                        "text": "未列入其他代码的综合零售服务"
                    },
                    {
                        "text": "通讯设备销售"
                    },
                    {
                        "text": "乐器商店"
                    },
                    {
                        "text": "音像制品商店与音像产品下载"
                    },
                    {
                        "text": "摄影摄像器材商店"
                    },
                    {
                        "text": "邮票和纪念币商店"
                    }
                ]
            },
            {
                "text": "大型家电专卖类",
                "children": [
                    {
                        "text": "家用电器商店"
                    }
                ]
            },
            {
                "text": "食品药品类",
                "children": [
                    {
                        "text": "医疗器械"
                    },
                    {
                        "text": "兽医服务"
                    },
                    {
                        "text": "药房、药店"
                    },
                    {
                        "text": "助听器销售"
                    },
                    {
                        "text": "医学检验与牙科设备服务"
                    },
                    {
                        "text": "仓储服务"
                    },
                    {
                        "text": "肉类水产商店"
                    },
                    {
                        "text": "糖果及坚果商店"
                    },
                    {
                        "text": "乳制品商店"
                    },
                    {
                        "text": "面包房、糕点商店"
                    },
                    {
                        "text": "未列入其他代码的食品商店"
                    },
                    {
                        "text": "瓶装酒销售商"
                    },
                    {
                        "text": "香烟、雪茄专卖店"
                    },
                    {
                        "text": "医疗护理和看护服务"
                    }
                ]
            },
            {
                "text": "一般服务类",
                "children": [
                    {
                        "text": "服装定制及修补改衣店"
                    },
                    {
                        "text": "干洗店"
                    },
                    {
                        "text": "理发店"
                    },
                    {
                        "text": "鞋帽清洗保养服务"
                    },
                    {
                        "text": "未列入其他代码的个人服务"
                    },
                    {
                        "text": "景观美化及园艺服务"
                    },
                    {
                        "text": "物业管理"
                    },
                    {
                        "text": "洗衣店"
                    },
                    {
                        "text": "自助洗衣服务"
                    },
                    {
                        "text": "室内清洁服务（地毯、沙发、家具表面的清洁服务）"
                    },
                    {
                        "text": "婚恋服务与婚庆公司"
                    },
                    {
                        "text": "个人咨询服务"
                    },
                    {
                        "text": "家政服务"
                    },
                    {
                        "text": "保洁服务"
                    },
                    {
                        "text": "职业介绍与人才服务"
                    },
                    {
                        "text": "安全保卫服务"
                    },
                    {
                        "text": "家具维修、翻新"
                    },
                    {
                        "text": "装修装潢服务"
                    },
                    {
                        "text": "农业合作"
                    },
                    {
                        "text": "救护车服务"
                    },
                    {
                        "text": "电报服务"
                    },
                    {
                        "text": "旅游相关服务直销"
                    },
                    {
                        "text": "门对门销售"
                    },
                    {
                        "text": "宠物商店、宠物食品及用品"
                    },
                    {
                        "text": "游泳池－销售、供应和服务"
                    },
                    {
                        "text": "殡葬、墓地服务"
                    },
                    {
                        "text": "广告服务"
                    },
                    {
                        "text": "商业摄影、平面设计"
                    },
                    {
                        "text": "复印及绘图服务"
                    },
                    {
                        "text": "办公、文秘服务"
                    },
                    {
                        "text": "灭虫及消毒服务"
                    },
                    {
                        "text": "网站运营与信息检索服务"
                    },
                    {
                        "text": "管理咨询与公共关系服务"
                    },
                    {
                        "text": "未列入其他代码的商业服务"
                    },
                    {
                        "text": "电器设备维修"
                    },
                    {
                        "text": "空调、制冷设备维修"
                    },
                    {
                        "text": "小家电维修"
                    },
                    {
                        "text": "焊接维修服务"
                    },
                    {
                        "text": "未列入其他代码的维修服务"
                    },
                    {
                        "text": "法律事务"
                    },
                    {
                        "text": "工业设计、建筑与工程设计"
                    },
                    {
                        "text": "会计、审计、财务服务"
                    },
                    {
                        "text": "未列入其他代码的专业服务"
                    },
                    {
                        "text": "快递公司"
                    },
                    {
                        "text": "照相馆、摄影工作室"
                    },
                    {
                        "text": "照片洗印服务"
                    }
                ]
            },
            {
                "text": "专业服务类",
                "children": [
                    {
                        "text": "铁路货运服务"
                    },
                    {
                        "text": "物流服务"
                    },
                    {
                        "text": "旅客航运服务"
                    },
                    {
                        "text": "码头、船只停泊与维修服务"
                    },
                    {
                        "text": "机场、停机坪、飞机停靠与维修服务"
                    },
                    {
                        "text": "未列入其他代码的运输服务"
                    },
                    {
                        "text": "汽车轮胎经销商"
                    },
                    {
                        "text": "汽车零配件商店"
                    },
                    {
                        "text": "海上船只遇难救助"
                    },
                    {
                        "text": "车体维修店"
                    },
                    {
                        "text": "轮胎翻新、维修店"
                    },
                    {
                        "text": "汽车喷漆店"
                    },
                    {
                        "text": "机动车维修保养"
                    },
                    {
                        "text": "洗车服务"
                    },
                    {
                        "text": "拖车服务"
                    },
                    {
                        "text": "观光与会展服务"
                    },
                    {
                        "text": "汽车协会"
                    },
                    {
                        "text": "税收准备服务"
                    },
                    {
                        "text": "电子游戏设备服务"
                    },
                    {
                        "text": "彩票销售"
                    },
                    {
                        "text": "证券公司－经纪人和经销商"
                    },
                    {
                        "text": "信用调查与征信服务"
                    },
                    {
                        "text": "宗教组织"
                    },
                    {
                        "text": "未列入其他代码的会员组织"
                    },
                    {
                        "text": "出租船只"
                    },
                    {
                        "text": "打字机商店－销售、服务和出租"
                    },
                    {
                        "text": "服装出租"
                    },
                    {
                        "text": "设备出租服务"
                    },
                    {
                        "text": "汽车出租"
                    },
                    {
                        "text": "卡车、拖车及农机出租"
                    },
                    {
                        "text": "房车和娱乐车辆出租"
                    },
                    {
                        "text": "音像制品出租服务"
                    },
                    {
                        "text": "商业和文秘学校"
                    },
                    {
                        "text": "职业技能培训"
                    },
                    {
                        "text": "其他学校和教育服务"
                    },
                    {
                        "text": "社会团体与行业协会"
                    },
                    {
                        "text": "网络接入服务"
                    },
                    {
                        "text": "计算机软件商店与软件下载"
                    },
                    {
                        "text": "计算机软件开发、系统集成、数据处理服务"
                    },
                    {
                        "text": "未列入其他代码的计算机维护和修理服务"
                    },
                    {
                        "text": "目录直销商户"
                    },
                    {
                        "text": "目录、零售兼营商户"
                    },
                    {
                        "text": "电话呼出直销"
                    },
                    {
                        "text": "电话呼入直销"
                    },
                    {
                        "text": "订阅/订购直销服务"
                    },
                    {
                        "text": "其他直销商户"
                    },
                    {
                        "text": "使领馆收费"
                    }
                ]
            },
            {
                "text": "一般票据类",
                "children": [
                    {
                        "text": "金融机构－人工现金支付"
                    },
                    {
                        "text": "金融机构-自动现金支付"
                    },
                    {
                        "text": "非金融机构提供的金融类服务"
                    }
                ]
            }
        ]
    },
    {
        "text": "批发类",
        "children": [
            {
                "text": "批发类",
                "children": [
                    {
                        "text": "机动车、农机零配件批发"
                    },
                    {
                        "text": "办公及商务家具批发"
                    },
                    {
                        "text": "建筑装饰材料批发商"
                    },
                    {
                        "text": "办公设备批发商"
                    },
                    {
                        "text": "计算机及外设批发"
                    },
                    {
                        "text": "未列入其他代码的商用机械设备批发"
                    },
                    {
                        "text": "医疗器械批发"
                    },
                    {
                        "text": "金属材料批发"
                    },
                    {
                        "text": "电器零件与通信器材批发"
                    },
                    {
                        "text": "五金批发"
                    },
                    {
                        "text": "管道与供暖设备批发"
                    },
                    {
                        "text": "文教用品批发"
                    },
                    {
                        "text": "药品批发"
                    },
                    {
                        "text": "纺织原料及日用品批发"
                    },
                    {
                        "text": "服装、化妆品、卫生用品批发"
                    },
                    {
                        "text": "鞋帽批发"
                    },
                    {
                        "text": "石化产品批发"
                    },
                    {
                        "text": "书报批发"
                    },
                    {
                        "text": "花卉苗木批发"
                    },
                    {
                        "text": "涂料批发"
                    },
                    {
                        "text": "其他批发商"
                    },
                    {
                        "text": "大型企业批发"
                    }
                ]
            }
        ]
    },
    {
        "text": "便民类",
        "children": [
            {
                "text": "便民类",
                "children": [
                    {
                        "text": "报亭、报摊"
                    },
                    {
                        "text": "停车场"
                    },
                    {
                        "text": "国家邮政服务"
                    }
                ]
            },
            {
                "text": "电信电视缴费类",
                "children": [
                    {
                        "text": "电信运营商"
                    },
                    {
                        "text": "付费电视"
                    }
                ]
            }
        ]
    },
    {
        "text": "超市加油类",
        "children": [
            {
                "text": "加油类",
                "children": [
                    {
                        "text": "加油、加气、充电站"
                    },
                    {
                        "text": "自助加油站"
                    }
                ]
            },
            {
                "text": "超市类",
                "children": [
                    {
                        "text": "综合性超级市场"
                    }
                ]
            }
        ]
    },
    {
        "text": "交通运输类",
        "children": [
            {
                "text": "航空售票类",
                "children": [
                    {
                        "text": "航空公司、航空客票销售"
                    }
                ]
            },
            {
                "text": "其他客运类",
                "children": [
                    {
                        "text": "本市和市郊通勤旅客运输（包括轮渡）"
                    },
                    {
                        "text": "出租车服务"
                    },
                    {
                        "text": "公路客运"
                    },
                    {
                        "text": "路桥通行费"
                    }
                ]
            }
        ]
    },
    {
        "text": "公共事业类",
        "children": [
            {
                "text": "公共事业类",
                "children": [
                    {
                        "text": "公共事业（电力、煤气、自来水、清洁服务）"
                    }
                ]
            }
        ]
    },
    {
        "text": "公益类",
        "children": [
            {
                "text": "医疗机构类",
                "children": [
                    {
                        "text": "医院"
                    },
                    {
                        "text": "其他医疗机构"
                    },
                    {
                        "text": "牙科诊所"
                    },
                    {
                        "text": "正骨医生"
                    },
                    {
                        "text": "按摩医生"
                    },
                    {
                        "text": "眼科医生"
                    },
                    {
                        "text": "手足病医生"
                    },
                    {
                        "text": "公共卫生服务机构"
                    }
                ]
            },
            {
                "text": "教育机构类",
                "children": [
                    {
                        "text": "中小学校"
                    },
                    {
                        "text": "普通高校"
                    },
                    {
                        "text": "学前教育"
                    },
                    {
                        "text": "函授学校（成人教育）"
                    }
                ]
            },
            {
                "text": "慈善及社会福利机构类",
                "children": [
                    {
                        "text": "社会福利与公益慈善组织"
                    }
                ]
            }
        ]
    },
    {
        "text": "政府类",
        "children": [
            {
                "text": "政府类",
                "children": [
                    {
                        "text": "政府机构"
                    },
                    {
                        "text": "法庭费用"
                    },
                    {
                        "text": "行政事业性收费、罚款"
                    },
                    {
                        "text": "保释金"
                    },
                    {
                        "text": "纳税"
                    },
                    {
                        "text": "未列入其他代码的政府服务（社会保险、社会保障服务）"
                    }
                ]
            }
        ]
    },
    {
        "text": "铁路售票类",
        "children": [
            {
                "text": "铁路售票类",
                "children": [
                    {
                        "text": "国家铁路总公司"
                    },
                    {
                        "text": "铁路客运"
                    }
                ]
            }
        ]
    },
    {
        "text": "保险类",
        "children": [
            {
                "text": "保险类",
                "children": [
                    {
                        "text": "保险公司"
                    },
                    {
                        "text": "保险服务商"
                    }
                ]
            }
        ]
    },
    {
        "text": "烟草类",
        "children": [
            {
                "text": "烟草类",
                "children": [
                    {
                        "text": "烟草配送"
                    }
                ]
            }
        ]
    },
    {
        "text": "信用卡还款类",
        "children": [
            {
                "text": "信用卡还款类",
                "children": [
                    {
                        "text": "信用卡还款"
                    }
                ]
            }
        ]
    },
    {
        "text": "其他类",
        "children": [
            {
                "text": "其他类",
                "children": [
                    {
                        "text": "大型仓储式家庭用品卖场"
                    },
                    {
                        "text": "会员制批量零售店"
                    }
                ]
            }
        ]
    }
]
